import { TAppState } from '../../types';

export const selectBuyPackageModalErrorMessage = (state: TAppState): string | undefined => {
  return state.buyPackage.message;
};
